import { Group, Stack, Text } from "@mantine/core";
import { IIssueBoardApi } from "@schemas/issueBoardSchema";
import React from "react";
import Switch from "react-switch";
import { FailedAlert } from "../../../../../components";
import { useUpdateIssueBoardRisikoIsActiveMutation } from "../../IssueBoardRTK";
import SettingsCardWrapper from "../SettingsCardWrapper";
import EvaluationCategories from "./EvaluationCategories/EvaluationCategories";
import RisikoProbabilitySettings from "./RisikoProbabilitySettings";

const IssueRisiko: React.FC<{ issueBoard: IIssueBoardApi }> = ({ issueBoard }) => {
  const [setRisikoActive, { error: activateRisikoError }] = useUpdateIssueBoardRisikoIsActiveMutation();

  return (
    <SettingsCardWrapper title={"Risiko"}>
      {activateRisikoError != null && <FailedAlert />}
      <Group align="center" gap="xs" wrap="nowrap">
        <Text size="1em">
          <i className="fa fa-info-circle fa-fw text-info" /> Aktiver risiko
        </Text>
        <Switch
          height={24}
          width={46}
          onColor="#00a76d"
          onChange={(risikoActive) =>
            setRisikoActive({
              projectId: issueBoard.project,
              issueBoardId: issueBoard._id,
              isActive: risikoActive,
            })
          }
          checked={issueBoard.risikoSection?.isActive === true}
        />
      </Group>

      {issueBoard.risikoSection?.isActive === true && (
        <Stack>
          <RisikoProbabilitySettings issueBoard={issueBoard} />
          <EvaluationCategories issueBoard={issueBoard} />
        </Stack>
      )}
    </SettingsCardWrapper>
  );
};

export default IssueRisiko;
